import { api } from "./base.api";

export const paymentsAPI = {
  getPixDetails: async (txid: string) => {
    const response = await api.get(`/payments/pix/${txid}`);
    return response.data;
  },
  createPrepaidPayment: async (
    amount: number,
    description: string,
    gateway: string = "efipay-card",
    paymentToken?: string
  ) => {
    const response = await api.post("/payments/prepaid", {
      amount,
      description,
      gateway,
      paymentToken,
    });
    return response.data;
  },

  createSubscriptionPayment: async (amount: number, description: string) => {
    const response = await api.post("/payments/subscription", {
      amount,
      description,
    });
    return response.data;
  },

  getPaymentStatus: async (id: string) => {
    const response = await api.get(`/payments/id/${id}`);
    return response.data;
  },

  getUserPayments: async () => {
    const response = await api.get("/payments");
    return response.data;
  },

  getAllPayments: async (page: number = 1, limit: number = 10) => {
    const response = await api.get("/payments/all", {
      params: { page, limit },
    });
    return response.data;
  },
};
